import { REQUEST_API_URL } from '@fukuri-admins/constants/common';
import { getToken } from '@fukuri-admins/utils/common/cookies';

type RequestInit = globalThis.RequestInit;
type HeadersInit = globalThis.HeadersInit;
type BodyInit = globalThis.BodyInit;
type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

interface FetchOptions {
  method: HttpMethod;
  data?: BodyInit | object;
  headers?: HeadersInit;
  isJson?: boolean;
  queryString?: string;
  threeLetterCode?: string;
}

const AUTH_ERROR_STATUS = 401;
const INTERNAL_ADMIN_THREE_LETTER_CODE = 'DEF';

export type FetchResponseMetadata = {
  status: number;
  ok: boolean;
  statusText: string;
  headers: Headers;
};

/**
 * fetchのラッパー
 * @param endpoint エンドポイント
 * @param options オプション
 * @param signOut サインアウト関数
 * @returns レスポンス
 */
export const fetchWrapper = async (
  endpoint: string,
  options: FetchOptions,
  signOut?: () => void
): Promise<Response> => {
  const url =
    REQUEST_API_URL +
    `/${options.threeLetterCode ? options.threeLetterCode : INTERNAL_ADMIN_THREE_LETTER_CODE}/company_admins${endpoint}${
      options.queryString ? `?${options.queryString}` : ''
    }`;
  const config = createRequestConfig(options);
  const response = await fetch(url, config);

  if (response.status === AUTH_ERROR_STATUS) {
    signOut?.();
  }
  if (!(response.status >= 200 && response.status < 300)) {
    const clonedResponse = response.clone();
    const error = await clonedResponse.json();
    const errorMessage =
      typeof error.errors === 'string'
        ? error.errors
        : JSON.stringify(error.errors || 'An unknown error occurred');
    throw new Error(errorMessage);
  }

  return response;
};

const createRequestConfig = (options: FetchOptions): RequestInit => {
  const config: RequestInit = {
    method: options.method,
    mode: 'cors',
    cache: 'no-store',
    headers: createHeaders(options),
    redirect: 'error',
  };

  if (options.data) {
    const isJson = options.isJson !== false;
    config.body = isJson ? JSON.stringify(options.data) : (options.data as BodyInit);
  }

  return config;
};

const createHeaders = (options: FetchOptions): HeadersInit => {
  const defaultHeaders: HeadersInit = {};
  if (options.isJson !== false) {
    defaultHeaders['Content-Type'] = 'application/json';
  }
  defaultHeaders.Authorization = `Bearer ${getToken()}`;

  return { ...defaultHeaders, ...options.headers };
};
